module.exports = __webpack_public_path__ + "c46ef2b6dea0283d944152a5869da19a.png";